import PosthogService from '~/services/posthog/PosthogService';

export interface IConfirmCandidateDeclineConfirmedPayload {
  shiftId: string;
}

/**
 * Fires when an office confirms the "Decline" action on the Decline offer pop-up
 * Event: dental_portal:confirm_candidate:decline_confirmed
 */
export function fireConfirmCandidateDeclineConfirmed(
  payload: IConfirmCandidateDeclineConfirmedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:confirm_candidate:decline_confirmed', {
    shift_id: payload.shiftId,
  });
}
